/**
 * Smart Entry Flow — client-side resolver mirroring backend/entry_flow.py.
 * Returns the active phase {mode, price_modifier, until} or null when smart
 * flow isn't enabled / configured (caller falls back to legacy behavior).
 */

const VALID_PHASE_MODES = new Set(['paid_approval', 'paid_auto', 'cash_rsvp']);

function parseIso(s) {
  if (!s) return null;
  const dt = new Date(s);
  return Number.isNaN(dt.getTime()) ? null : dt;
}

export function resolveEntryMode(event, now) {
  if (!event || typeof event !== 'object') return null;
  const mode = (event.entry_mode || '').trim().toLowerCase();
  if (mode !== 'smart_flow') return null;
  const flow = event.entry_flow;
  if (!Array.isArray(flow) || flow.length === 0) return null;

  const ts = now || new Date();
  let lastValid = null;
  for (const phase of flow) {
    if (!phase || typeof phase !== 'object') continue;
    const phaseMode = (phase.mode || '').trim().toLowerCase();
    if (!VALID_PHASE_MODES.has(phaseMode)) continue;
    const modifier = Number.isFinite(Number(phase.price_modifier))
      ? Number(phase.price_modifier)
      : 0;
    const normalized = { mode: phaseMode, price_modifier: modifier, until: phase.until || null };
    lastValid = normalized;
    const untilDt = parseIso(phase.until);
    if (untilDt === null) return normalized; // open-ended terminal phase
    if (ts <= untilDt) return normalized;
  }
  return lastValid;
}
